import React from 'react';
import { Heart } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FavoritesPage() {
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" data-id="element-328">
      <div className="text-center max-w-md" data-id="element-329">
        <div className="bg-white p-6 rounded-full inline-flex mb-6 shadow-sm" data-id="element-330">
          <Heart className="w-12 h-12 text-kithward-700 fill-current" data-id="element-331" />
        </div>
        <h1 className="text-3xl font-serif font-bold text-gray-900 mb-4" data-id="element-332">
          Your Favorites
        </h1>
        <p className="text-gray-500 text-lg mb-8" data-id="element-333">
          Save brands and products you love to quickly access them later. Start
          exploring to add your first favorite!
        </p>
        <Link to="/explore" className="inline-flex items-center justify-center px-8 py-4 bg-kithward-700 text-white rounded-full font-bold text-lg hover:bg-kithward-800 transition-colors shadow-lg hover:shadow-xl" data-id="element-334">
          Start Exploring
        </Link>
      </div>
    </div>;
}